// libraries
import { fetchAndActivate, getAll } from "firebase/remote-config";

// services
import { auth, remoteConfig } from "../services/firebase.service";
import { emulatorConfig } from "wombat-global/src/config/emulator";
import {
  deriveFeatureFlags,
  parseRemoteFetch,
  RemoteConfigType,
  alwaysOnFeatures,
  defaultConfig,
} from "wombat-global/src/config";
import { FeatureFlags } from "wombat-global/src/feature-flag";

export class WombatConfig {
  private config: RemoteConfigType;
  availableFlags: FeatureFlags;
  defaultOnFlags: FeatureFlags;

  constructor() {
    const usingEmulator = Boolean(auth.emulatorConfig);
    remoteConfig.settings.fetchTimeoutMillis = 60000;
    // Remote config stores the available feature flags
    remoteConfig.defaultConfig = usingEmulator ? emulatorConfig : defaultConfig;

    this.config = usingEmulator ? emulatorConfig : defaultConfig;
    this.availableFlags = deriveFeatureFlags(this.config);
    this.defaultOnFlags = deriveFeatureFlags(alwaysOnFeatures);

    if (usingEmulator) {
      return;
    }

    fetchAndActivate(remoteConfig).then(() => {
      this.config = parseRemoteFetch(this.config, getAll(remoteConfig));
      this.availableFlags = deriveFeatureFlags(this.config);
    });
  }
}
const wombatConfig = new WombatConfig();

export default wombatConfig;
